import React, { lazy, Suspense, useEffect, useMemo, useState } from "react";
import {
    MaterialReactTable,
    // createRow,
    type MRT_ColumnDef,
    type MRT_Row,
    type MRT_TableOptions,
    useMaterialReactTable,
} from "material-react-table";
import { Box, Button, IconButton, TextField, Tooltip } from "@mui/material";
import {
    QueryClient,
    QueryClientProvider,
    useMutation,
    useQuery,
    useQueryClient,
} from "@tanstack/react-query";
import { type User, fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Row } from "reactstrap";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
const PnlSummaryPage = () => {
    const [age, setAge] = React.useState("");

    const handleChange = (event: SelectChangeEvent) => {
        setAge(event.target.value);
    };
    const [validationErrors, setValidationErrors] = useState<
        Record<string, string | undefined>
    >({});

    const columns = useMemo<MRT_ColumnDef<User>[]>(
        () => [
            {
                accessorKey: "id",
                header: "Id",
                enableEditing: false,

                // minSize: 40,
                // maxSize: 100,
            },
            {
                accessorKey: "companyName",
                header: "company Name",
                //  size: "auto",
                // minSize: 100,
                // maxSize: 200,
                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.customerCompany,
                    helperText: validationErrors?.customerCompany,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            customerCompany: undefined,
                        }),
                    //optionally add validation checking for onBlur or onChange
                },
            },

            {
                accessorKey: "companyBook",
                header: "Book",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.email,
                    helperText: validationErrors?.email,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            email: undefined,
                        }),
                },
            },

            {
                accessorKey: "strategy",
                header: "strategy",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },
            {
                accessorKey: "futuresPNL",
                header: "futuresPNL",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },
            {
                accessorKey: "futuresDailyChange",
                header: "futuresDailyChange",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },

            {
                accessorKey: "swapsPNL",
                header: "swapsPNL",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },
            {
                accessorKey: "swapsDailyChange",
                header: "swapsDailyChange",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },

            {
                accessorKey: "totalPNL",
                header: "totalPNL",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },

            {
                accessorKey: "totalDailyChange",
                header: "totalDailyChange",

                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.remarks,
                    helperText: validationErrors?.remarks,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            remarks: undefined,
                        }),
                },
            },


            // {
            //   accessorKey: "state",
            //   header: "State",

            //   filterVariant: "multi-select",
            //   filterSelectOptions: usStateList,
            //   editVariant: "select",
            //   editSelectOptions: usStates,

            //   muiEditTextFieldProps: {
            //     select: true,
            //     error: !!validationErrors?.state,
            //     helperText: validationErrors?.state,
            //   },
            // },
        ],
        [validationErrors]
    );

    //call CREATE hook
    const { mutateAsync: createUser, isPending: isCreatingUser } =
        useCreateUser();
    //call READ hook
    const {
        data: fetchedUsers = [],
        isError: isLoadingUsersError,
        isFetching: isFetchingUsers,
        isLoading: isLoadingUsers,
    } = useGetUsers();
    //call UPDATE hook
    const { mutateAsync: updateUser, isPending: isUpdatingUser } =
        useUpdateUser();
    //call DELETE hook
    const { mutateAsync: deleteUser, isPending: isDeletingUser } =
        useDeleteUser();

    //CREATE action
    const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
        values,
        table,
    }) => {
        const newValidationErrors = validateUser(values);
        if (Object.values(newValidationErrors).some((error) => error)) {
            setValidationErrors(newValidationErrors);
            return;
        }
        setValidationErrors({});
    };

    //UPDATE action
    const handleSaveUser: MRT_TableOptions<User>["onEditingRowSave"] = async ({
        values,
        table,
    }) => {
        const newValidationErrors = validateUser(values);
        if (Object.values(newValidationErrors).some((error) => error)) {
            setValidationErrors(newValidationErrors);
            return;
        }
        setValidationErrors({});
        await updateUser(values);
        table.setEditingRow(null); //exit editing mode
    };

    //DELETE action
    const openDeleteConfirmModal = (row: MRT_Row<User>) => {
        showDeleteConfirmModal({
            title: "Delete Entry",
            content: `Are you sure you want to delete this user?`,
            onOk: () => {
                deleteUser(row.original.id);
            },
        });
    };

    const table = useMaterialReactTable({
        columns,

        // enableColumnResizing:true,
        enableColumnPinning: true,
        data: fetchedUsers,
        enableDensityToggle: false,
        createDisplayMode: "row", // ('modal', and 'custom' are also available)
        editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
        enableEditing: true,
        enableColumnOrdering: true, // ✅ Enables column drag-and-drop
        enableRowOrdering: false, // ✅ Enables row drag-and-drop
        getRowId: (row) => row.id,
        enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
        initialState: { showColumnFilters: true }, //show filters by default

        filterFns: {
            customFilterFn: (row, id, filterValue) => {
                return row.getValue(id) === filterValue;
            },
        },
        // muiTableProps: {
        //   sx: {
        //     border: '1px solid rgba(81, 81, 81, .5)',
        //     caption: {
        //       captionSide: 'top',
        //     },
        //   },
        // },
        muiTableHeadCellProps: {
            sx: {
                border: "1px solid #e0e0e087",
                fontStyle: "italic",
                fontWeight: "normal",
            },
        },
        muiTableBodyCellProps: {
            sx: {
                border: "1px solid #ebe9e98f",
            },
        },
        muiTablePaperProps: {
            elevation: 0,
            sx: {
                borderRadius: "0",
                border: "0",
            },
        },
        localization: {
            filterCustomFilterFn: "Custom Filter Fn",
        } as any,

        muiToolbarAlertBannerProps: isLoadingUsersError
            ? {
                color: "error",
                children: "Error loading data",
            }
            : undefined,
        muiTableContainerProps: {
            sx: {
                minHeight: "500px",
            },
        },

        onCreatingRowCancel: () => setValidationErrors({}),
        onCreatingRowSave: handleCreateUser,
        onEditingRowCancel: () => setValidationErrors({}),
        onEditingRowSave: handleSaveUser,

        renderRowActions: ({ row, table }) => (
            <Box sx={{ display: "flex", gap: "1rem" }}>
                <Tooltip title="Edit" className="editIcon">
                    <IconButton onClick={() => table.setEditingRow(row)}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete" className="deleteIcon">
                    <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),

        state: {
            isLoading: isLoadingUsers,
            isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
            showAlertBanner: isLoadingUsersError,
            showProgressBars: isFetchingUsers,
            showColumnFilters: true,
        },
    });

    return (
        <div className="page-body">
            <Container fluid>
                <Row>
                    <div>
                        <div className="table-ad">

                            <div className="table-ad__wrapper">
                                <MaterialReactTable table={table} />
                            </div>
                        </div>
                    </div>
                </Row>
            </Container>
        </div>
    );
};

//CREATE hook (post new user to api)
function useCreateUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (user: User) => {
            //send api update request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve();
        },
        //client side optimistic update
        onMutate: (newUserInfo: User) => {
            queryClient.setQueryData(
                ["users"],
                (prevUsers: any) =>
                    [
                        ...prevUsers,
                        {
                            ...newUserInfo,
                            id: (Math.random() + 1).toString(36).substring(7),
                        },
                    ] as User[]
            );
        },
        // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//READ hook (get users from api)
function useGetUsers() {
    return useQuery<User[]>({
        queryKey: ["users"],
        queryFn: async () => {
            //send api request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve(fakeData);
        },
        refetchOnWindowFocus: false,
    });
}

//UPDATE hook (put user in api)
function useUpdateUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (user: User) => {
            //send api update request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve();
        },
        //client side optimistic update
        onMutate: (newUserInfo: User) => {
            queryClient.setQueryData(["users"], (prevUsers: any) =>
                prevUsers?.map((prevUser: User) =>
                    prevUser.id === newUserInfo.id ? newUserInfo : prevUser
                )
            );
        },
        // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (userId: string) => {
            //send api update request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve();
        },
        //client side optimistic update
        onMutate: (userId: string) => {
            queryClient.setQueryData(["users"], (prevUsers: any) =>
                prevUsers?.filter((user: User) => user.id !== userId)
            );
        },
        // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
    import("@tanstack/react-query-devtools/build/modern/production.js").then(
        (d) => ({
            default: d.ReactQueryDevtools,
        })
    )
);

const queryClient = new QueryClient();

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <PnlSummaryPage />
            <Suspense fallback={null}>
                <ReactQueryDevtoolsProduction />
            </Suspense>
        </QueryClientProvider>
    );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
    !!email.length &&
    email
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

function validateUser(user: User) {
    return {
        // customerCompany: !validateRequired(user.customerCompany)
        //   ? "Customer Company is Required"
        //   : "",
        //   account: !validateRequired(user.account) ? "account is Required" : "",
        // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
        // remarks: !validateEmail(user.remarks) ? "Incorrect Email Format" : "",
        // creditLimit:validateEmail(user.remarks) ? "Incorrect Email Format" : "",
    };
}
